import { Component, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser';
import { slideUp } from '../shared/animations';

declare var $: any;

@Component({
    selector: 'home',
    template: require('./home.component.html'),
    styles: [require('./home.component.scss')],
    animations: [slideUp]
})

export class HomeComponent implements OnInit {
    constructor(private title: Title) {}

    ngOnInit() {
        $('#lnkMail').hover(function () {
            let newHref = $(this).attr('href').replace('spam', 'sk');
            $(this).attr('href', newHref);
        });
        this.title.setTitle('Web scraping - golang opensource framework/Dataflow kit');
    }
}


